function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("metadata", null);
var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.38589 0 0 .38269 -.063368 1.6148)",
  fillRule: "evenodd",
  strokeWidth: 2.6022
}, React.createElement("path", {
  className: "icon-secondary",
  d: "m24.681 84.657c-16.918-4.83-26.717-22.461-21.886-39.379 1.715-6.008 5.16-11.379 9.904-15.445l20.729 24.191z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m54.593 30.214c13.15 11.689 14.334 31.825 2.645 44.975-8.133 9.15-20.789 12.829-32.56 9.467l8.75-30.632z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m12.77 29.772c12.13-10.332 30.028-10.113 41.901 0.512l-21.243 23.74z",
  fill: "#ecaec6"
}), React.createElement("path", {
  className: "icon-secondary",
  d: "m99.074 32.305c12.039-12.829 32.2-13.47 45.03-1.43 4.556 4.276 7.754 9.797 9.196 15.876l-30.996 7.354z",
  fill: "#adb9ca"
}), React.createElement("path", {
  d: "m133.78 83.822c-16.412 6.34-34.856-1.826-41.196-18.238-4.41-11.419-1.888-24.356 6.49-33.281l23.228 21.802z",
  fill: "#fff"
}), React.createElement("path", {
  className: "icon-primary",
  d: "m153.32 46.842c3.632 15.514-4.756 31.326-19.638 37.018l-11.38-29.755z",
  fill: "#ecaec6"
}));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.38589 0 0 .38269 -.063368 1.6148)",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 2.6022
}, React.createElement("path", {
  className: "icon-tertiary",
  d: "m24.58 84.585 8.756-30.654 21.214-23.671",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m12.699 29.833 20.636 24.098",
  strokeMiterlimit: 8
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m9.237 74.753c-11.448-13.361-9.898-33.472 3.462-44.92 13.361-11.448 33.472-9.898 44.92 3.463 11.448 13.36 9.898 33.471-3.463 44.919-13.36 11.448-33.471 9.898-44.919-3.462z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m99.184 32.248 23.245 21.818 11.332 29.697",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m153.3 46.751-30.872 7.3146",
  strokeMiterlimit: 8
}), React.createElement("path", {
  className: "icon-tertiary",
  d: "m114.95 23.108c17.119-4.061 34.289 6.524 38.35 23.643 4.062 17.119-6.524 34.29-23.643 38.351s-34.289-6.524-38.35-23.643 6.524-34.289 23.643-38.351z",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}));
var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "icon-tertiary",
  d: "m30.032 1.5916c2.5515 0.02602 5.0027 0.86718 7.0105 2.3654l1.4517 1.3452 2.8143-2.1706-0.18214 6.9336-6.821-1.5323 2.2918-1.7676-2.6657-1.998c-1.2171-0.56102-2.5523-0.86756-3.9234-0.88172-1.3711-0.01416-2.7124 0.2652-3.9407 0.80136l-2.8687 2.06 2.3157 1.786-6.821 1.5323-0.18214-6.9336 2.8004 2.1599 1.6616-1.4776c2.0383-1.4573 4.5068-2.2483 7.0587-2.2223z",
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#002060",
  strokeMiterlimit: 8
});
var SvgMenuComparison = function SvgMenuComparison(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    overflow: "hidden",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuComparison, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-comparison.a100035f.svg";
export { ForwardRef as ReactComponent };